export { default as Detail } from './Detail';
export { default as List } from './List';
